var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageViewHeaderWithActionBar',{attrs:{"title":_vm.$t('검색 일정 더보기')}}),_c('ScheduleSearchContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }